import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import { Row, Col, Button, Input, Modal, ModalHeader, ModalBody, Badge } from 'reactstrap';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import GetInventoryLogsService from '../../../../../../../Service/OPSServices/StoreHealthServices/GetInventoryLogsService';

function InventoryLogs(props) {
  const [logsData, setLogsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [isDateCleared, setIsDateCleared] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalJsonContent, setModalJsonContent] = useState('');

  const fetchLogs = () => {
    if (!props.token) return;
    setLoading(true);
    GetInventoryLogsService(props.token)
      .then((res) => {
        setLoading(false);
        if (res && res.status && Array.isArray(res.logs)) {
          setLogsData(res.logs);
        } else if (Array.isArray(res)) {
          setLogsData(res);
        } else if (res && res.logs && Array.isArray(res.logs)) {
          setLogsData(res.logs);
        } else {
          setLogsData([]);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error('Failed to load inventory logs:', err);
      });
  };

  useEffect(() => {
    fetchLogs();
  }, [props.token]);

  const handleOpenJsonModal = (title, data) => {
    let formatted = '';
    try {
      if (typeof data === 'string') {
        formatted = JSON.stringify(JSON.parse(data), null, 2);
      } else if (data !== null && data !== undefined) {
        formatted = JSON.stringify(data, null, 2);
      } else {
        formatted = '{}';
      }
    } catch (e) {
      formatted = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
    }
    setModalTitle(title);
    setModalJsonContent(formatted);
    setModalOpen(true);
  };

  const formatFilterDate = (date) => {
    if (!date) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const columns = [
    {
      Header: 'Store Name',
      accessor: 'storeName',
      minWidth: 140,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100" style={{ overflow: 'hidden' }}>
          <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
        </div>
      ),
    },
    {
        Header: 'Integer ID',
        accessor: 'integerId',
        minWidth: 140,
        Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100" style={{ overflow: 'hidden' }}>
            <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
            </div>
        ),
    },
    {
      Header: 'Seller Partner ID',
      accessor: 'sellerPartnerID',
      minWidth: 140,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100" style={{ overflow: 'hidden' }}>
          <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
        </div>
      ),
    },
    {
      Header: 'Marketplace',
      accessor: 'MarketplaceId',
      width: 130,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100" style={{ overflow: 'hidden' }}>
          <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
        </div>
      ),
    },
    {
      Header: 'Module',
      accessor: 'Module',
      minWidth: 150,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100" style={{ overflow: 'hidden' }}>
          <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
        </div>
      ),
    },
    {
      Header: 'Endpoint Name',
      accessor: 'EndPointName',
      minWidth: 180,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100" style={{ overflow: 'hidden' }}>
          <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
        </div>
      ),
    },
    {
      Header: 'Input JSON',
      accessor: 'InputJson',
      width: 90,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <Button
            color="link"
            size="sm"
            className="p-0"
            disabled={!cellInfo.value || (Array.isArray(cellInfo.value) && cellInfo.value.length === 0)}
            onClick={() => handleOpenJsonModal(`Input JSON - ${cellInfo.original.EndPointName || ''}`, cellInfo.value)}
          >
            View
          </Button>
        </div>
      ),
    },
    {
      Header: 'Output JSON',
      accessor: 'OutputJson',
      width: 90,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <Button
            color="link"
            size="sm"
            className="p-0"
            disabled={!cellInfo.value || (Array.isArray(cellInfo.value) && cellInfo.value.length === 0)}
            onClick={() => handleOpenJsonModal(`Output JSON - ${cellInfo.original.EndPointName || ''}`, cellInfo.value)}
          >
            View
          </Button>
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'Status',
      width: 100,
      Cell: (cellInfo) => {
        const val = String(cellInfo.value || '');
        const isSuccess = val === '200' || val.toLowerCase() === 'success';
        return (
          <div className="d-flex justify-content-center w-100">
            <Badge
              color={isSuccess ? 'success' : 'danger'}
              pill
              style={{
                fontSize: '12px',
                padding: '5px 12px',
                fontWeight: '500',
              }}
            >
              {val || 'N/A'}
            </Badge>
          </div>
        );
      },
    },
    {
      Header: 'Created At',
      accessor: 'CreatedAt',
      width: 140,
      Cell: (cellInfo) => {
        if (!cellInfo.value) {
          return (
            <div className="d-flex justify-content-center w-100">
              <p className="mb-0">-</p>
            </div>
          );
        }
        const parts = String(cellInfo.value).split(' ');
        const datePart = parts[0];
        const timePart = parts.slice(1).join(' ');
        return (
          <div
            className="d-flex flex-column align-items-center justify-content-center w-100"
            style={{ overflow: 'hidden' }}
            title={cellInfo.value}
          >
            <p className="mb-0 text-truncate">{datePart}</p>
            {timePart && <p className="mb-0 text-truncate">{timePart}</p>}
          </div>
        );
      },
    },
    {
      Header: 'Created By',
      accessor: 'CreatedBy',
      minWidth: 140,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100" style={{ overflow: 'hidden' }}>
          <p className="mb-0 text-truncate" title={cellInfo.value || ''}>{cellInfo.value || '-'}</p>
        </div>
      ),
    },
  ];

  const filteredLogs = logsData.filter((row) => {
    const targetDate = selectedDate
      ? formatFilterDate(selectedDate)
      : (!isDateCleared ? formatFilterDate(new Date()) : null);

    if (targetDate) {
      const rowDate = (row.CreatedAt || '').slice(0, 10);
      if (rowDate !== targetDate) return false;
    }

    if (!searchText) return true;
    const q = searchText.toLowerCase().trim();
    return Object.values(row).some((val) => {
      if (val === null || val === undefined) return false;
      if (typeof val === 'object') {
        try {
          return JSON.stringify(val).toLowerCase().includes(q);
        } catch (e) {
          return false;
        }
      }
      return String(val).toLowerCase().includes(q);
    });
  });

  return (
    <>
      <Row className="mb-3">
        <Col md={12} className="d-flex justify-content-end align-items-center">
          <div className="position-relative mr-2" style={{ width: '200px' }}>
            <FaCalendarAlt
              style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                pointerEvents: 'none',
                color: '#495057',
              }}
            />
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                if (!date) {
                  setIsDateCleared(true);
                } else {
                  setIsDateCleared(false);
                }
              }}
              dateFormat="MM/dd/yyyy"
              placeholderText="Select Date"
              isClearable={true}
              wrapperClassName="w-100"
              customInput={
                <input
                  className="form-control"
                  style={{ paddingLeft: '32px' }}
                />
              }
            />
          </div>
          <Input
            type="text"
            placeholder="Search...."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: '220px' }}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <ReactTable
            data={filteredLogs}
            columns={columns}
            loading={loading}
            className="-fixed -highlight -striped"
            getTheadProps={() => ({
              style: {
                overflowY: 'hidden',
                background: '#B1FA63',
              },
            })}
            defaultPageSize={20}
            pageSizeOptions={[10, 20, 50, 100]}
            noDataText={loading ? 'Loading Logs...' : 'No Logs Found.'}
          />
        </Col>
      </Row>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg" className="curve-popup">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          {modalTitle}
        </ModalHeader>
        <ModalBody>
          <pre
            style={{
              backgroundColor: '#1e1e1e',
              color: '#d4d4d4',
              padding: '15px',
              borderRadius: '6px',
              maxHeight: '500px',
              overflow: 'auto',
              fontSize: '12px',
              fontFamily: 'Consolas, Monaco, Courier New, monospace',
            }}
          >
            {modalJsonContent}
          </pre>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(InventoryLogs);